import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";
import ManageColours from "./ManageColours";
import ManageUsers from "./ManageUsers";
import DebugTools from "./DebugTools";
import SystemTools from "./SystemTools";
import ManageOffering from "./ManageOffering";
import ManageProductList from "./ManageProductList";
import ManageMaterials from "./ManageMaterials";

const useStyles = makeStyles({
    root: {
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        height: "calc(100% - 46px)",
    },
});

export default function Admin(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [page, setPage] = React.useState(props?.page ? props?.page : null);
    const user = useSelector((state) => state.app.user);

    // const [materials, setMaterials] = React.useState(null);
    // const [pricefile, setPricefile] = React.useState(null);
    // const [pricefileDescSummary, setPricefileDescSummary] = React.useState(null);
    // const [cds_docs, setCDSOffering] = React.useState(null);
    // const [lld_docs, setLLDOffering] = React.useState(null);
    // const [materialsKeys, setMaterialsKeys] = React.useState(null);

    let functions = [{ Key: "Manage Users", Display: "Manage Businesses/Users" }];

    if (user?.Role === 99) {
        functions = [
            { Key: "Manage Users", Display: "Businesses/Users" },
            { Key: "System", Display: "Announcements" },
            { Key: "Product List", Display: "Product List" },
            { Key: "Manage Materials", Display: "Materials" },
            { Key: "Manage Offering", Display: "Offering" },
            { Key: "Diagnostics", Display: "Diagnostics" },
            // { Key: "Colour List", Display: "Colour List" },
        ];
    }

    return (
        <div className={classes.root}>
            <SegmentedButtonGroup
                value={page}
                items={functions}
                onChange={(e, val) => {
                    setPage(val);
                }}
                style={{
                    flex: "inherit",
                }}
            />

            {page === "Colour List" && <ManageColours />}
            {/* {page === "Product List" && !window.debug && (
                <iframe
                    src={"https://www.qikquotecentenary.com/price_file_design_cloud/?psw=centenary_2021"}
                    width="100%"
                    height="90%"
                    // src={"http://localhost:3100/"} width="100%" height="100%" crossOrigin="anonymous"
                ></iframe>
            )} */}
            {page === "Product List" && (
                <ManageProductList
                // materials={materials}
                // setMaterials={setMaterials}
                // pricefile={pricefile}
                // setPricefile={setPricefile}
                // pricefileDescSummary={pricefileDescSummary}
                // setPricefileDescSummary={setPricefileDescSummary}
                />
            )}
            {page === "Manage Offering" && (
                <ManageOffering
                // pricefile={pricefile}
                // setPricefile={setPricefile}
                // pricefileDescSummary={pricefileDescSummary}
                // setPricefileDescSummary={setPricefileDescSummary}
                // cds_docs={cds_docs}
                // setCDSOffering={setCDSOffering}
                // lld_docs={lld_docs}
                // setLLDOffering={setLLDOffering}
                // materialsKeys={materialsKeys}
                // setMaterialsKeys={setMaterialsKeys}
                />
            )}
            {page === "Manage Materials" && (
                <ManageMaterials
                // materials={materials}
                // setMaterials={setMaterials}
                // pricefile={pricefile}
                // setPricefile={setPricefile}
                // pricefileDescSummary={pricefileDescSummary}
                // setPricefileDescSummary={setPricefileDescSummary}
                // cds_docs={cds_docs}
                // setCDSOffering={setCDSOffering}
                // lld_docs={lld_docs}
                // setLLDOffering={setLLDOffering}
                />
            )}
            {page === "Manage Users" && <ManageUsers />}
            {page === "Diagnostics" && <DebugTools />}
            {page === "System" && <SystemTools />}
        </div>
    );
}
